import { skipToken } from '@reduxjs/toolkit/query'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_PLAN_SERVER } from '@/app/module/plans/definitions'
import { selectActiveOrg } from '@/app/module/user/store/selectors'
import { hasTotpError } from '@/app/service/util/error'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'
import { Organization } from '@/app/types'

export const useGetPlan = () => {
  const dispatch = useAppDispatch()
  const activeOrg = useSelector(selectActiveOrg) as Organization | undefined
  const orgId = activeOrg?.orgId

  const skip = !orgId || !activeOrg?.permissions?.plans
  const res = esApi.endpoints.getOrgPlan.useQuery(skip ? skipToken : { orgId: orgId.toString() })

  useEffect(() => {
    if (!res.error || hasTotpError(res.error)) {
      return
    }

    dispatch(
      createNotification({
        'get-plan-error': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_PLAN_SERVER),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
